<template>
    <base-component :taxpayerInfo="currentTaxpayer">
        <template slot="form">
            <kkm-search-form :fetch="getKkmList" :tax-org-list="$store.getters.getTaxOrgs"
                :initial-data="currentTaxpayer || $route.params" :pageSize="pageSize" :offset="offset" :setOffset="setOffset"/>
        </template>
        <template slot="createButton">
            <b-btn v-if="!showCreateKkm && isOperator && Object.keys($route.params).length && this.currentTaxpayer" variant="primary" @click="toggleCreateKkm">
                <plus-icon title="" />&nbsp;{{ $t('general.create') }}
            </b-btn>
        </template>
        <template slot="createForm">
            <kkm-create-form v-if="showCreateKkm" :to-kkm-list="getKkmList" :close-form="toggleCreateKkm"
                :inspections="$store.getters.getTaxOrgs" />
        </template>
        <template slot="workArea">
            <b-alert variant="danger" :show="showAlert">
                {{ alert }}
            </b-alert>
            <b-card no-body class="flex-fill flex-shrink-0">
                <b-tabs card>
                    <b-tab :title="$t('menu.kkms')">
                        <pagination :pageSize="this.pageSize" :offset="offset" :listLength="kkmList.length" :setOffset="setOffset"/>
                        <kkm-list-view :items="kkmList" :taxOrgs="taxOrgs"
                            :hideAlert="hideAlert" :refresh-kkm-list="getKkmList" />
                    </b-tab>
                    <b-tab v-if="!isInspector && $route.params.dealerId == null" :title="$t('menu.blockedKkms')" @click="openBlockedKkms"></b-tab>
                    <b-tab v-if="!isOperator" :title="$t('menu.reports')" @click="openReports"></b-tab>
                    <b-tab v-if="!isOperator" :title="$t('menu.tickets')" @click="openTickets"></b-tab>
                    <b-tab v-if="!isOperator" :title="$t('menu.moneyPlacements')" @click="openMoneyPlacements"></b-tab>
                    <b-tab v-if="!isOperator" :title="$t('menu.tasks')" @click="openTasks"/>
                </b-tabs>
            </b-card>
        </template>
    </base-component>
</template>

<script>
/* eslint-disable */
import AppData from '@/utils/appdata';
import { normalizeArrayOfCcm } from '@/utils/utils';

const KkmCreateForm = () => import(/* webpackChunkName: "chunk-views" */ '@/components/kkm/KkmCreateForm.vue')
const KkmSearchForm = () => import(/* webpackChunkName: "chunk-views" */ '@/components/kkm/KkmSearchForm.vue')
const KkmListView = () => import(/* webpackChunkName: "chunk-views" */ '@/components/kkm/KkmListView.vue')
const Pagination = () => import(/* webpackChunkName: "chunk-views" */ '@/components/general/Pagination.vue')

export default {
    name: 'Kkm',
    mixins: [ AppData ],
    components: {
        KkmCreateForm,
        KkmSearchForm,
        KkmListView,
        Pagination
    },
    mounted() {
        this.getCurrentTaxpayer();
        
        const fetch = (id) => {
            this.getKkmList({
                dealerId: id,
                offset: this.offset,
                pageSize: this.pageSize
            })
        };
        
        if (Object.keys(this.$route.params).length || this.currentTaxpayer) {
            fetch(this.$route.params.id || this.$route.params.dealerId || this.currentTaxpayer.id);  
        } else if (this.isTaxpayer) {
            //This is workaround for Bug 223  
            const unsubscribe = this.$store.subscribe((mutation, state) => {
                if (mutation.type === 'setTaxpayer') {
                    if (state.taxpayer != null)
                        fetch(state.taxpayer.id);
                    
                    unsubscribe();
                }
            });
        } 
    },
    data() {
        return {
            showCreateKkm: false,
            kkmList: [],
            pageSize: 20,
            offset: 0
        }
    },
    methods: {
        getKkmList(formData) {
            this.hideAlert();

            const onSuccess = response => {
                this.kkmList = normalizeArrayOfCcm(response, ccm => {
                    if (ccm.ofdStatus != null && ccm.ofdStatus === 'ERROR' || ccm.isBlocked != null && ccm.isBlocked)
                        ccm._rowVariant = 'danger';

                    ccm._showDetails = false;
                });
            };

            this.$request.sendRequest(
                this, 
                this.$appConfig.apiUrls.kkm.getAll,
                formData, 
                onSuccess,
                this.displayAlert);
        },
        toggleCreateKkm() {
            this.hideAlert()
            this.showCreateKkm = !this.showCreateKkm
        },
        openReports() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'reports' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childReports' })
            }
        },
        openTickets() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'tickets' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childTickets' })
            }
        },
        openMoneyPlacements() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'moneyPlacements' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childMoneyPlacements' })
            }
        },
        openBlockedKkms() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'kkmsBlocked' })
            } else if (this.isOperator) {
                this.$router.push({ name: 'blockedKkms' })
            }
        },
        setOffset(newValue) {
            this.offset = newValue
        },
        openTasks() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'tasks' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childTasks' })
            }
        }
    }
}
</script>
